
import './style.less'

import { h, Fragment } from 'preact'
import classnames from 'classnames'


const Container = ({ stripes, narrow, children, ...props }) => {

	const classNames = (props.class || props.className || '').split(' ')

	const classes = classnames(
		'container',
		stripes && 'stripes',
		narrow && 'container--narrow',
		...classNames
	)

	delete props['class']
	delete props['className']

	return (
		<div class={classes} {...props}>
			<div className="container__inner">
				{children}
			</div>
		</div>
	)
}

export default Container